<template>
  <v-data-table
    height="55vh"
    fixed-header
    :headers="headers"
    :items="this.$store.state.clientMember"
    sort-by="rowId"
    class="elevation-1"
  >
    <template v-slot:top>
      <div class="pa-5">
        <div class="row viewList">
          <div class="col-sm-12 col-md-4 col-lg-2">
            <v-select
              v-model="selectQ"
              :items="$store.state.questCmb"
              item-text="name"
              item-value="value"
              label="請選擇"
              persistent-hint
              return-object
              single-line
            ></v-select>
            <!-- <v-select :items="items" v-model="select" label="查詢條件" dense outlined ></v-select> -->
            <v-text-field
              v-model="queryCon"
              v-bind:label="selectQ.placeholder"
              single-line
              hide-details
            ></v-text-field>
          </div>

          <div class="col-sm-12 col-md-4 col-lg-2">
            <v-select
              v-model="selectU"
              :items="$store.state.userType"
              item-text="name"
              item-value="value"
              label="Select"
              persistent-hint
              return-object
              single-line
            ></v-select>
            <!-- <v-select :items="items" v-model="select" label="查詢條件" dense outlined ></v-select> -->
          </div>

          <div class="col-sm-12 col-md-2 col-lg-1">
            <v-btn
              large
              color="primary"
              dark
              class="mb-2"
              aria-setsize="16px"
              block
              @click="query"
              >查詢</v-btn
            >
          </div>
          <div class="col-sm-12 col-md-2 col-lg-1">
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn
                  large
                  color="primary"
                  dark
                  class="mb-2"
                  aria-setsize="16px"
                  v-on="on"
                  block
                  >新增</v-btn
                >
              </template>

              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-row>
                        <v-col cols="12" sm="6" md="12">
                          <v-select
                            v-model="$store.state.quesData.questSysId"
                            :items="surveys"
                            item-text="questTitle"
                            item-value="questSysId"
                            label="請選擇問卷"
                            persistent-hint
                            menu-props="auto"
                            return-object
                            dense
                            outlined
                            v-on:change="
                              changeQuest(
                                `${$store.state.quesData.questSysId.clientUserType}`
                              )
                            "
                          ></v-select>
                        </v-col>
                        <v-col v-if="curClientUserType == '10'" cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.corpVAT"
                            label="公司統編"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.userId"
                            label="使用者帳號"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.userName"
                            label="使用者姓名"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">取消</v-btn>
                  <v-btn color="blue darken-1" text @click="validate" :disabled="!valid"
                    >儲存</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4">
            <template>
              <v-file-input show-size label="匯入" v-model="importFile"></v-file-input>
            </template>
          </div>
          <div class="col-sm-12 col-md-2 col-lg-1">
            <v-btn
              large
              color="primary"
              dark
              class="mb-2"
              aria-setsize="16px"
              block
              @click="doImport()"
            >
              匯入
            </v-btn>
          </div>
        </div>
      </div>
    </template>
    <!-- <template v-slot:item.actions="{ item }"> -->
    <template v-slot:[`item.actions`]="{ item }">
      <!-- <v-btn class="mx-2" depressed fab dark small color="primary" @click="editItem(item)"> -->
      <!-- <v-icon dark>mdi-pencil</v-icon> -->
      <!-- </v-btn> -->
      <v-btn
        class="mx-2"
        depressed
        fab
        dark
        small
        color="grey lighten-1"
        @click="deleteItem(item)"
      >
        <v-icon dark>mdi-delete</v-icon>
      </v-btn>
    </template>
    <template v-slot:no-data></template>
  </v-data-table>
</template>
<script>
export default {
  mounted() {
    this.$store.state.clientMember = []
    let url = this.$store.state.api + '/Q01030/GetM'
    window.console.log(url)
    this.axios(url).then(res => {
      this.surveys = res.data.questMList
      if (this.$store.state.quesData.questSysId === null) {
        if (this.surveys[0] !== null) {
          $store.state.quesData.questSysId = this.surveys[0].questSysId
          window.console.log(this.surveys[0].questSysId)
        }
      }
      window.console.log(this.surveys)
      // todo 指定 questSysId 到 select 元件的 value
    })

    window.console.log(this.$store.state.quesData)
  },
  data: () => ({
    importFile: null,
    valid: true,
    queryCon: '',
    dialog: false,
    disabled: false,
    selectQ: { name: '請選擇', value: null, placeholder: '' },
    selectU: { name: '請選擇', value: null, placeholder: '' },
    headers: [
      { text: '問卷編號', value: 'questSysId' },
      { text: '問卷名稱', value: 'questTitle' },
      { text: '公司統編', value: 'corpVAT' },
      { text: '使用者帳號', value: 'userId' },
      { text: '使用者姓名', value: 'userName' },
      { text: '建立人員', value: 'creatUserName', sortable: false },
      { text: '建立時間', value: 'creatTime' },
      { text: '異動人員', value: 'actUserName', sortable: false },
      { text: '異動時間', value: 'actTime' },

      { text: '', value: 'actions', sortable: false }
    ],
    userData: [],
    surveys: [],
    curClientUserType: '',
    editedIndex: -1,
    editedItem: {
      corpVAT: '',
      userId: '',
      userName: ''
    },
    defaultItem: {
      corpVAT: '',
      userId: '',
      userName: ''
    }
  }),

  computed: {
    formTitle() {
      return '新增指定填寫對象'
      //return this.editedIndex === -1 ? '新增使用者' : '使用者維護'
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.initialize()
  },

  methods: {
    doImport() {
      // 確認是否有選擇會員種類、檔案
      if (this.selectU.value !== '10' && this.selectU.value !== '20') {
        alert('請先選擇會員種類，且會員種類僅限商業師會員、商業獅管理人員')
        return
      }
      if (!this.importFile) {
        alert('尚未選擇檔案')
        return
      }

      // 將資料加入 formData
      let formData = new FormData()
      formData.append('file', this.importFile)
      formData.append('userType', this.selectU.value)

      // 進行 ajax
      let url = this.$store.state.api + '/Q01030/UploadFile'
      this.axios
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(res => {
          if (res.data.resultCode != '10') {
            //throw res.data.error
            alert(res.data.error)
          } else {
            // 成功處理
            var rows = res.data.rows
            var questName = res.data.questName
            window.console.log(questName)
            for (var i = 0; i < res.data.rows.length; i++) {
              var row = rows[i]
              window.console.log(row)
              //this.$store.state.clientMember.splice(0)
              this.$store.state.clientMember.push(row)
            }
            alert('匯入成功')
          }
        })
    },
    initialize() {},
    changeQuest(clientUserType) {
      if (clientUserType == 20) {
        this.editedItem.corpVAT = ''
      }
      this.curClientUserType = clientUserType
      window.console.log(clientUserType)
    },
    editItem(item) {
      this.disabled = true
      this.editedIndex = this.$store.state.users.indexOf(item)
      this.editedItem = Object.assign({}, item)
      //this.$store.state.users = Object.assign({}, item)
      this.dialog = true
    },
    query() {
      window.console.log(this.selectQ.value)
      window.console.log(this.selectU.value)
      window.console.log(this.queryCon)

      let url = this.$store.state.api + '/Q01030/QueryClientMember'
      let data = Object.assign(
        { queryType: this.selectQ.value },
        { queryCon: this.queryCon },
        { clientUserType: this.selectU.value }
      )
      this.axios.post(url, this.qs.stringify(data)).then(res => {
        //先把store舊的清掉
        this.$store.state.clientMember.splice(0)
        if (res.data.resultCode == '10') {
          var rows = res.data.rows
          for (var i = 0; i < res.data.rows.length; i++) {
            var row = rows[i]

            window.console.log(row)
            this.$store.state.clientMember.push(row)
          }
        } else {
          alert(res.data.error)
        }
      })
    },
    deleteItem(item) {
      const index = this.$store.state.clientMember.indexOf(item)
      confirm('確認是否刪除此帳號?') && this.delete(item.questSysId, item.userId, index)
    },
    delete(questSysId, userId, index) {
      window.console.log(questSysId, userId, index)
      let url = this.$store.state.api + '/Q01030/DeleteClientMember'
      let data = Object.assign({ questSysId: questSysId, userId: userId })
      this.axios.post(url, this.qs.stringify(data)).then(res => {
        if (res.data.resultCode == '10') {
          this.$store.state.clientMember.splice(index, 1)
          alert('刪除成功!!')
        } else {
          alert(res.data.error)
        }
      })
    },
    close() {
      this.disabled = false
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    validate() {
      this.$refs.form.validate()
      if (this.editedIndex == -1) {
        let url = this.$store.state.api + '/Q01030/ActClientMember'
        this.editedItem.questSysId = this.$store.state.quesData.questSysId.questSysId
        let data = Object.assign(
          { questSysId: this.editedItem.questSysId },
          { corpVAT: this.editedItem.corpVAT },
          { userId: this.editedItem.userId },
          { userName: this.editedItem.userName }
        )
        this.axios.post(url, this.qs.stringify(data)).then(res => {
          if (res.data.resultCode == '10') {
            this.editedItem.questTitle = this.$store.state.quesData.questSysId.questTitle
            this.editedItem.creatTime = res.data.creatTime
            this.editedItem.creatUserName = res.data.creatUserName
            window.console.log(this.editedItem)
            this.$store.state.clientMember.push(this.editedItem)
          } else {
            alert(res.data.error)
          }
        })
      }

      this.close()
    }
  }
}
</script>
